import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RoutingService } from './routing.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
  providers: [
    RoutingService,
  ],
  exports: [],
})
export class NavigationModule { }
